<template>
    <v-container :fluid="true">
        <v-row>
            <v-col class="mx-auto" cols="8">
                <v-card elevation="3">
                    <v-card-title id="heading" class="d-flex justify-space-between">
                        <h4>Your Company</h4>
                        <!--<v-btn
                            v-if="user.id === user.company.owner_id || user.role.toLowerCase().includes('admin')"
                            :disabled="usersDialogSwitch" class="me-3"
                            color="black"
                            size="small"
                            @click="usersDialogSwitch = true">Users
                        </v-btn>-->
                    </v-card-title>
                    <v-form :readonly="user.id !== user.company.owner_id && !user.role?.toLowerCase()?.includes('admin')" class="mb-3"
                            validate-on="input lazy" @submit.prevent="updateCompany">
                        <v-container>
                            <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                                     density="compact" variant="tonal">
                                <p v-for="error in errors">{{ error }}</p>
                            </v-alert>
                            <v-row>
                                <v-col cols="12">
                                    <v-avatar :image="image" size="150"/>
                                    <v-btn v-if="user.id === user.company.owner_id" flat icon size="small"
                                           @click="$refs.imageHandle.click()">
                                        <v-icon icon="mdi-pencil"></v-icon>
                                    </v-btn>
                                    <v-file-input ref="imageHandle" v-model="formData['file']" accept="image/*"
                                                  class="d-none"
                                                  @change="()=>{ validateFileSize()?imagePreview():''}"
                                    />
                                    <p v-if="user.type === 'company' && user.role?.toLowerCase()?.includes('admin')">Account Number:
                                        {{ company?.account_code ?? '' }}</p>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['company_name']"
                                                  :rules="[vRules.required, vRules.maxLength(50)]"
                                                  density="compact" label="Company Name"/>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['short_name']"
                                                  :rules="[vRules.required, vRules.maxLength(32)]" density="compact"
                                                  label="Short Name"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['contact_name']"
                                                  :rules="[vRules.required, vRules.maxLength(50)]"
                                                  density="compact" label="Contact Name"/>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['email']" :rules="[vRules.required, vRules.email]"
                                                  density="compact" label="Email"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['phone']" :rules="[vRules.required]"
                                                  density="compact"
                                                  label="Phone"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['addr_1']" :rules="[vRules.required]"
                                                  density="compact"
                                                  label="Address 1"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['addr_2']" density="compact" label="Address 2"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['addr_district']" :rules="[vRules.required]"
                                                  density="compact" label="District"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['addr_city']" :rules="[vRules.required]"
                                                  density="compact"
                                                  label="City"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['addr_state']" :rules="[vRules.required]"
                                                  density="compact"
                                                  label="State"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['addr_postalcode']" :rules="[vRules.required]"
                                                  density="compact" label="Postal Code"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-autocomplete v-model="formData['addr_country']" :items="countries"
                                                    :rules="[vRules.required]" density="compact" label="Country"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="formData['speed_threshold']" density="compact"
                                                  label="Base Speed Threshold" type="number"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-select v-model="formData['speed_unit']" :items="['miles','km']" density="compact"
                                              label="Speed Unit"/>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-autocomplete v-model="formData['timezone']" :items="timezones" clearable
                                                    density="compact" label="Company Timezone"
                                                    hint="Used to localize alert and report times" persistent-hint/>
                                </v-col>

                                <v-col cols="12" style="height: 300px">
                                    <l-map ref="mapContainer" :center="mapCenter" :zoom="20" @ready="mapIsReady">
                                        <l-tile-layer :url="$mapTiles.street"/>
                                    </l-map>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-card-actions v-if="user.id === user.company.owner_id || (user.type === 'company' && user.role?.toLowerCase()?.includes('admin'))"
                                        class="px-4 d-flex justify-end">
                            <v-btn color="primary" size="small" type="submit">Save</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <Company-Users v-if="usersDialogSwitch" v-model="usersDialogSwitch" :all-users="null" :company="company"
                   :roles="roles"/>
    <Locations v-if="locationsDialogSwitch" v-model="locationsDialogSwitch" :company="company"/>
</template>

<script setup>
import "leaflet-draw/dist/leaflet.draw.css";

import "leaflet-draw";
import L from "leaflet";
import {ref, reactive, onMounted, watch} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {LMap, LTileLayer} from "@vue-leaflet/vue-leaflet";
import Locations from "@/components/dialogs/companies/Locations/Index.vue";
import CompanyUsers from "@/components/dialogs/companies/Users/Index.vue";
import {GeoSearchControl, OpenStreetMapProvider} from "leaflet-geosearch";
import {mapTiles} from "@/composables/mapConfig";
import countries from "@/assets/js/countries.json";

const mapContainer = ref();
const roles = ref([]);
const errors = ref([]);
const image = ref(null);
const company = ref(null);
const formData = reactive({});
const {showSnackbar} = useSnackbarStore();
const usersDialogSwitch = ref(false);
const locationsDialogSwitch = ref(false);
const {user, updateAuthCompany} = useAuthStore();
const mapCenter = ref([47.41322, -1.219482]);
// Full IANA zone list for the Company Timezone picker; empty on older browsers
// that lack Intl.supportedValuesOf (the field then just keeps the saved value).
const timezones = ref(
    typeof Intl.supportedValuesOf === 'function' ? Intl.supportedValuesOf('timeZone') : []
);

watch(company, (companyInfo) => {
    formData['contact_name'] = companyInfo?.contact_name ?? null;
    formData['short_name'] = companyInfo?.short_name ?? null;
    formData['company_name'] = companyInfo?.company_name ?? null;
    formData['email'] = companyInfo?.email ?? null;
    formData['phone'] = companyInfo?.phone ?? null;
    formData['addr_1'] = companyInfo?.addr_1 ?? null;
    formData['addr_2'] = companyInfo?.addr_2 ?? null;
    formData['addr_district'] = companyInfo?.addr_district ?? null;
    formData['addr_city'] = companyInfo?.addr_city ?? null;
    formData['addr_state'] = companyInfo?.addr_state ?? null;
    formData['addr_postalcode'] = companyInfo?.addr_postalcode ?? null;
    formData['addr_country'] = companyInfo?.addr_country ?? null;
    formData['speed_threshold'] = companyInfo?.speed_threshold ?? null;
    formData['speed_unit'] = companyInfo?.speed_unit ?? null;
    formData['timezone'] = companyInfo?.timezone ?? null;
    formData['polygon_coordinates'] = companyInfo?.polygon_coordinates?.map((coordinate) => {
        return {'lat': coordinate.latitude, 'lng': coordinate.longitude};
    }) ?? [];
    drawPolygon(formData['polygon_coordinates']);
});

onMounted(() => {
    // Fetch Company
    send('get', `companies/user-company`)
        .then(function (response) {
            company.value = response.data.data.company;
            image.value = company.value?.company_logo;
            mapCenter.value = [company.value?.polygon_coordinates[0]?.lat ?? 47.41322, company.value?.polygon_coordinates[0]?.lng ?? -1.219482];
        }).catch(function (errorResponse) {
        console.log(errorResponse)
        showSnackbar(errorResponse.response.data.message, 'error');
    });

    // Fetch Roles
    if (user.id === user.company.owner_id || user.role.toLowerCase().includes('admin')) {
        fetchRoles()
    }
})
const imagePreview = () => {
    formData['file'] = formData['file'];
    image.value = URL.createObjectURL(formData['file']);
}
const validateFileSize = () => {
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    if (formData['file'].size > maxSize) {
        showSnackbar("File size exceeds 2MB. Please upload a smaller file.", 'error');
        return false;
    }
    return true;
}

function mapIsReady() {
    const map = mapContainer.value.leafletObject;
    map.attributionControl.remove();
    if (user.id === user.company.owner_id) {
        const geoSearchOptions = new GeoSearchControl({
            style: "bar",
            autoClose: true,
            keepResult: true,
            showMarker: false,
            searchLabel: "Enter address",
            provider: new OpenStreetMapProvider({searchUrl: mapTiles.searchUrl, reverseUrl: mapTiles.reverseUrl}),
        });
        map.addControl(geoSearchOptions);
    }
}

function drawPolygon(coordinates) {
    const map = mapContainer.value.leafletObject;
    const drawnItems = new L.FeatureGroup();
    map.addLayer(drawnItems);
    const polygon = L.polygon(coordinates ?? [], {
        // editable: true,
    });
    drawnItems.addLayer(polygon);
    mapCenter.value = polygon.getBounds()['_northEast'];

    /*Add Draw Tool Bar Control*/
    if (user.id === user.company.owner_id) {
        map.addControl(new L.Control.Draw({
            draw: {
                circle: false,
                polygon: {
                    showArea: true,
                    allowIntersection: false, // Restricts shapes to simple polygons
                    drawError: {
                        color: '#9d1212', // Color the shape will turn when intersects
                        message: '<strong>Oh snap!<strong> you can\'t draw that!' // Message that will show when intersect
                    }
                },
                // disable toolbar item by setting it to false
                marker: false,
                polyline: false,
                rectangle: false,
                circlemarker: false,
            },
            edit: {
                featureGroup: drawnItems
            }
        }));

        map.on('draw:created', function (e) {
            drawnItems.eachLayer(function (layer) {
                drawnItems.removeLayer(layer);
            });

            let type = e.layerType,
                layer = e.layer;

            if (type === 'polygon') {
                formData['polygon_coordinates'] = layer.getLatLngs()[0];
            }
            drawnItems.addLayer(layer);
        });

        map.on('draw:edited', function (e) {
            e.layers.eachLayer(function (layer) {
                if (layer instanceof L.Polygon) {
                    formData['polygon_coordinates'] = layer.getLatLngs()[0];
                }
            });
        });

        map.on('draw:deleted', function (e) {
            drawnItems.eachLayer(function (layer) {
                drawnItems.removeLayer(layer);
            });
            formData['polygon_coordinates'] = null;
        });
    }
}


const fetchRoles = () => {
    send('get', `roles`)
        .then((response) => {
            roles.value = response.data.data;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Roles could not be loaded', 'error')
        })
}
const updateCompany = () => {
    errors.value = [];
    send('post', `companies/user-company`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then((response) => {
            const {id, owner_id, company_name, company_logo} = response.data.data.company;
            updateAuthCompany({id, owner_id, company_name, company_logo});
            showSnackbar(response.data.message);
        })
        .catch(function (errorResponse) {
            if (errorResponse.response.data.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
